import React, { memo } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import CommonButton from '../../../components/common-button/CommonButton';

const AllProjectButton = () => {
  const { t } = useTranslation('header');
  const navigate = useNavigate();

  const handleRedirectToProjects = () => {
    navigate('/projects');
  };

  return (
    <CommonButton styleColor='primary' maxWidth={120} onClick={handleRedirectToProjects}>
      {t('allProjects')}
    </CommonButton>
  );
};

export default memo(AllProjectButton);
